import { useTranslation } from "react-i18next";

import { ChartCard, DonutChart } from "@/components/Elements/Charts";
import ListStatisticsCardExtra from "@/components/ListStatistics/ListStatisticsCardExtra";
import {
  useListStatistics,
  useListDonutChartSelected,
} from "@/components/ListStatistics/ListStatisticsHooks";
import { useReferentialAssetStates } from "@/entities/referential/referential-states";
import { useTranslateNumber } from "@/modules/translate";

const STATS_DATA_KEY = "states";
const FILTER_KEY = "state";

const AssetsStateDonutChart = () => {
  const { t } = useTranslation();
  const { translateNumber } = useTranslateNumber();

  const { getState } = useReferentialAssetStates();

  const { loading, fetching, statsData } = useListStatistics({
    statsDataKey: STATS_DATA_KEY,
    filterKey: FILTER_KEY,
  });

  const chartData = Object.entries(statsData)
    .map(([key, value]) => {
      const stateObj = getState(key, "value");
      return stateObj
        ? { name: stateObj.value, value, color: stateObj.color }
        : undefined;
    })
    .filter(Boolean);

  const { selectedLegend, onLegendSelectChange } = useListDonutChartSelected({
    filterKey: FILTER_KEY,
    chartData,
  });

  return (
    <ChartCard
      title={t("asset:statistics.state.title")}
      extra={<ListStatisticsCardExtra filterKey={FILTER_KEY} />}
    >
      <DonutChart
        data={chartData}
        loading={loading}
        fetching={fetching}
        controlled={{ selectedLegend }}
        onLegendSelectChange={onLegendSelectChange}
        formatName={(stateValue) =>
          getState(stateValue, "value")?.name ?? stateValue
        }
        formatTooltipValue={translateNumber}
      />
    </ChartCard>
  );
};

export default AssetsStateDonutChart;
